import {useCallback} from 'react';
import {deleteNorafUpdateIgnorelistItem} from 'api/agentNoraf';
import {useGetTokens} from 'services/auth';

export const useDeleteNorafUpdateIgnorelistItem = () => {
  const getTokens = useGetTokens();

  return useCallback(
    (id: string, mock?: boolean) => {
      return deleteNorafUpdateIgnorelistItem(getTokens, id, mock);
    },
    [getTokens],
  );
};
